import * as Types from '../constants/actionTypes';


export default (state = { isPending: false, currenciesList: [], error: '' }, action) => {
    switch (action.type) {
        case Types.CURRENCIES_DETAIL_SUCCESS:
            return Object.assign({}, state, { currenciesList: action.payload, isPending: false })

        case Types.CURRENCIES_ADDED_SUCCESS:
            state.currenciesList.push(action.payload)
            return {
                ...state
            }

        case Types.CURRENCIES_DELETED_SUCCESS:
            const newList = state.currenciesList.filter((currency) => currency.id !== action.payload )
            return {
                ...state,
                currenciesList : newList,
                deletedStatus:action.payload
            }
        /* currencyes list */
        case Types.LIST_ALL_CURRENCIES:
            return {
                ...state,
                allCurrencies: action.allCurrencies
            }
        case Types.CURRENCY_ERROR: {
            return {
                ...state,
                currencyError: action.currencyError
            }
        }
        case Types.CURRENCIES_UPDATED_SUCCESS:
            state.currenciesList[action.updateIndex] = action.payload
            return {
                ...state,
                updatedStatus: action.payload
            }
        case Types.CURRENCY_INFO_COUNT_SUCCESS:
                return Object.assign({}, state, { currencyInfoCount: action.payload})                
        case Types.CURRENCY_UPLOAD_SUCCESS:
            return {
                ...state,
                currencyUploadSuccess: action.payload
            }
        default:
            return state
    }
}
